/*
 * Copyright (c) 2026 Roboto Technologies, Inc.
 */
import * as React from "react";

import { UsageLimit } from "@/shared/components/UsageLimit";
import { AiCreditUsage } from "@/shared/domain/limits";

import { formatAiCreditUsage } from "./aiCreditFormatter";

export interface AiCreditUsageCardProps {
  usage: AiCreditUsage;
}

/**
 * Settings → Usage card showing the org's agent unit consumption for the
 * current month against the configured monthly cap. When the org's cap is the
 * "unlimited" sentinel, the limit reads "Unlimited" and the bar sits empty,
 * rather than showing a percentage of a cap that does not exist.
 */
export const AiCreditUsageCard: React.FC<AiCreditUsageCardProps> = ({
  usage,
}) => {
  const { currentValue, limitValue, currentPercent } =
    formatAiCreditUsage(usage);

  return (
    <UsageLimit
      title="Agent Units (RAU)"
      currentValue={currentValue}
      currentPercent={currentPercent}
      limitValue={limitValue}
      monthly={true}
    />
  );
};
